/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getOneDirectionForAllDefinitionsRpc = {
  serviceName: 'com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc',
  rpcName: 'getOneDirectionForAllDefinitions',
  auth: 'app',
  fingerprint: 'CbzSzFnq3ulKSdlMBfjVt5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDefinitionsFromObjectTypeRpc = {
  serviceName: 'com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc',
  rpcName: 'getDefinitionsFromObjectType',
  auth: 'app',
  fingerprint: 'cNMZK374kTNKSdlMBfjVt5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllBaseUnlabeledDefinitionsRpc = {
  serviceName: 'com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc',
  rpcName: 'getAllBaseUnlabeledDefinitions',
  auth: 'app',
  fingerprint: 'fMdfrxfw-wRKSdlMBfjVt5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHydratedDefinitionsFromObjectTypeRpc = {
  serviceName: 'com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc',
  rpcName: 'getHydratedDefinitionsFromObjectType',
  auth: 'app',
  fingerprint: 'c04UIVhnOSsjWoeVQVn6p5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};